export class CommunicationManager {
  constructor(channel) {
    this.channel = channel; // The channel name used for message filtering
  }

  sendMessage(message) {
    // Send message to the current origin
    window.postMessage({ channel: this.channel, ...message }, window.location.origin);
  }

  receiveMessage(callback) {
    window.addEventListener("message", (event) => {
      // Check if the message's origin matches this window's origin
      // and if the message channel matches this instance's channel
      if (event.origin === window.location.origin && event.data.channel === this.channel) {
        callback(event.data);
      }
    });
  }
}
